module.exports = __webpack_public_path__ + "static/media/9DESA7.b6e24718.jpg";